import { render, staticRenderFns } from "./headFeeDetailPriceEach.vue?vue&type=template&id=2ff8b540&scoped=true&"
import script from "./headFeeDetailPriceEach.vue?vue&type=script&lang=js&"
export * from "./headFeeDetailPriceEach.vue?vue&type=script&lang=js&"
import style0 from "./headFeeDetailPriceEach.vue?vue&type=style&index=0&id=2ff8b540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8b540",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})
